import { Component } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import Base from "../Base";

export const GET_PROFILE_DATE = "GET_PROFILE_DATE";

@Component
export default class Me extends Base {
  getProfileLastDate(profileSlug: string, tag: string) {
    const url = API_ENDPOINT + `/${profileSlug}/me/last_date.json`;
    return this.$store.dispatch("http/request", {
      tag,
      url,
      method: "GET",
    });
  }
}
